if (!customElements.get('pdp-sticky-atc')) {
  customElements.define(
    'pdp-sticky-atc',
    class PdpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.addButton = this.querySelector(`#StickyAtcSubmit-${this.sectionId}`);
        this.cartButton = this.querySelector(`#StickyAtcCart-${this.sectionId}`);
        this.cartCount = this.querySelector('[data-sticky-cart-count]');

        this.addButton?.addEventListener('click', this.onAddClick.bind(this));
        this.cartButton?.addEventListener('click', this.onCartClick.bind(this));

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));

        this.syncFromMainSubmitButton();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      onAddClick(event) {
        event.preventDefault();
        const mainSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainSubmit || mainSubmit.disabled) return;
        mainSubmit.click();
      }

      onCartClick(event) {
        event.preventDefault();
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }
        cartDrawer.open(this.cartButton);
      }

      onVariantChange({ data }) {
        if (!data || data.sectionId !== this.sectionId) return;

        const sourcePrice = data.html.getElementById(`StickyAtcPrice-${this.sectionId}`);
        const destinationPrice = document.getElementById(`StickyAtcPrice-${this.sectionId}`);
        if (sourcePrice && destinationPrice) {
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }

        const sourceLabel = data.html.getElementById(`StickyAtcLabel-${this.sectionId}`);
        const destinationLabel = document.getElementById(`StickyAtcLabel-${this.sectionId}`);
        if (sourceLabel && destinationLabel) {
          destinationLabel.innerHTML = sourceLabel.innerHTML;
        }

        this.syncFromMainSubmitButton(data.html);
      }

      onCartUpdate({ cartData }) {
        if (!cartData || cartData.item_count === undefined) return;
        this.updateCartCount(cartData.item_count);
      }

      syncFromMainSubmitButton(html) {
        const mainSubmit =
          html?.getElementById(`ProductSubmitButton-${this.sectionId}`) ||
          document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!mainSubmit || !this.addButton) return;

        this.addButton.disabled = mainSubmit.disabled;
        this.addButton.setAttribute('aria-disabled', mainSubmit.getAttribute('aria-disabled') === 'true');
      }

      updateCartCount(count) {
        if (!this.cartCount) return;

        const displayCount = count < 100 ? count : '99+';
        this.cartCount.textContent = displayCount;
        this.cartCount.classList.toggle('hidden', count === 0);

        if (this.cartButton) {
          const label = window.cartStrings?.cart || 'Cart';
          this.cartButton.setAttribute('aria-label', count > 0 ? `${label} (${count})` : label);
        }
      }
    }
  );
}
